export default "__VITE_ASSET__CWeifOMl__"